import * as React from 'react';
import { Field, FieldRenderProps } from 'react-final-form';
import { VFFieldProps } from '../types';
import { FormItem } from './FormItem';
import classNames from 'classnames';
import { MultiFileInput } from '../../file/MultiFileInput';

export type FileProps = Omit<
  VFFieldProps<React.ComponentProps<typeof MultiFileInput>>,
  'value'
>;
export const MultiFile = React.forwardRef<HTMLInputElement, FileProps>(
  (
    {
      name,
      inlineValidation,
      validate,
      className,
      inputClassName,
      contentClassName,
      label,
      required,
      disabled,
      validateWarning,
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        inlineValidation={inlineValidation}
        className={className}
        label={label}
        required={required}
        disabled={disabled}
        validateWarning={validateWarning}
        contentClassName={contentClassName}
      >
        <Field name={name}>
          {({ input: { value, onChange }, meta }: FieldRenderProps<any>) => {
            return (
              <MultiFileInput
                {...other}
                disabled={disabled || meta.submitting}
                className={classNames(inputClassName)}
                onChange={(newValue) => {
                  onChange({ target: { name, value: newValue } });
                }}
                // onBlur={(newValue) => {
                //   onBlur({
                //     target: { name, value: newValue },
                //   } as any as React.FocusEvent<HTMLElement>);
                // }}
                value={value}
                // @ts-ignore
                ref={ref}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
